var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "criteria" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "config-grid" }, [
      _c("div", { staticClass: "threshold-card" }, [
        _c("div", { staticClass: "threshold-card__head" }, [
          _vm._v("Thresholds"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "threshold-card__body" }, [
          _c("div", { staticClass: "threshold-field" }, [
            _c("label", { attrs: { for: "rpd-at" } }, [
              _vm._v("Acceptance threshold (AT)"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "threshold-field__row" },
              [
                _c("v-text-field", {
                  attrs: {
                    id: "rpd-at",
                    value: _vm.thresholds.acceptanceThreshold,
                    type: "number",
                    min: "0",
                    step: "0.1",
                    "hide-details": "",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.setThreshold("acceptanceThreshold", $event)
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "unit" }, [_vm._v("%")]),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", { staticClass: "explain" }, [
              _vm._v(
                "\n            Default " +
                  _vm._s(_vm.defaults.acceptanceThreshold) +
                  ". A row fails only when RPD is\n            "
              ),
              _c("em", [_vm._v("strictly greater")]),
              _vm._v(" than AT; an RPD equal to AT passes.\n          "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "threshold-field" }, [
            _c("label", { attrs: { for: "rpd-dlmt" } }, [
              _vm._v("Detection-limit multiplier (DLMT)"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "threshold-field__row" },
              [
                _c("v-text-field", {
                  attrs: {
                    id: "rpd-dlmt",
                    value: _vm.thresholds.detectionLimitMultiplier,
                    type: "number",
                    min: "0",
                    step: "0.1",
                    "hide-details": "",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.setThreshold(
                        "detectionLimitMultiplier",
                        $event
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "unit" }, [_vm._v("×")]),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", { staticClass: "explain" }, [
              _vm._v(
                "\n            Default " +
                  _vm._s(_vm.defaults.detectionLimitMultiplier) +
                  ". A result below\n            "
              ),
              _c("code", [_vm._v("DLMT × DetectionLimit")]),
              _vm._v(" is flagged "),
              _c("code", [_vm._v("BelowDLMT")]),
              _vm._v(".\n          "),
            ]),
          ]),
          _vm._v(" "),
          _vm._m(2),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "exclusions" },
        [
          _c("div", { staticClass: "exclusions__head" }, [
            _c("h3", [_vm._v("Excluded analytes")]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("span", { staticClass: "field-note" }, [
              _vm._v(
                _vm._s(_vm.excludedCount) +
                  " of " +
                  _vm._s(_vm.catalogue.length) +
                  " excluded"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("RpdVerdictBand", { attrs: { band: _vm.permissiveNote } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "picker" },
            [
              _c(
                "div",
                {
                  staticClass: "picker__chips",
                  attrs: {
                    "aria-label": "Analytes excluded from the calculation",
                  },
                },
                _vm._l(_vm.excludedAnalytes, function (analyte) {
                  return _c("span", { key: analyte.id, staticClass: "chip" }, [
                    _vm._v(
                      "\n            " + _vm._s(analyte.name) + "\n            "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "chip__close",
                        attrs: {
                          type: "button",
                          "aria-label": "Re-include " + analyte.name,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.toggle(analyte.id)
                          },
                        },
                      },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "material-icons",
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v("close")]
                        ),
                      ]
                    ),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              !_vm.excludedCount
                ? _c("p", { staticClass: "picker__chips-empty" }, [
                    _vm._v(
                      "\n          Nothing is excluded yet. Every analyte the two samples share is calculated.\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "picker__search" },
                [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_vm._v("search")]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "sr-only",
                      attrs: { for: "rpd-excl-search" },
                    },
                    [_vm._v("Search analytes to exclude")]
                  ),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      id: "rpd-excl-search",
                      value: _vm.search,
                      type: "search",
                      placeholder:
                        "Search the tenant's " +
                        _vm.catalogue.length +
                        " analytes…",
                      "hide-details": "",
                    },
                    on: {
                      input: function ($event) {
                        _vm.search = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "field-note" }, [
                    _vm._v(
                      "Showing " +
                        _vm._s(_vm.matches.length) +
                        " of " +
                        _vm._s(_vm.catalogue.length)
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.loading
                ? _c("v-progress-linear", {
                    attrs: { height: 2, color: "info", indeterminate: "" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "picker__options",
                  attrs: {
                    role: "listbox",
                    "aria-multiselectable": "true",
                    "aria-label": "Analytes in this tenant",
                  },
                },
                _vm._l(_vm.matches, function (analyte) {
                  return _c(
                    "li",
                    {
                      key: analyte.id,
                      staticClass: "picker__option",
                      attrs: {
                        role: "option",
                        tabindex: "0",
                        "aria-selected": _vm.isExcluded(analyte.id)
                          ? "true"
                          : "false",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggle(analyte.id)
                        },
                        keydown: [
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                            return _vm.toggle(analyte.id)
                          },
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "space", 32, $event.key, [
                                " ",
                                "Spacebar",
                              ])
                            )
                              return null
                            $event.preventDefault()
                            return _vm.toggle(analyte.id)
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.isExcluded(analyte.id)
                                  ? "check_box"
                                  : "check_box_outline_blank"
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "picker__option-name" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(analyte.name) +
                            "\n              "
                        ),
                        analyte.fraction && analyte.fraction !== "-"
                          ? _c("span", { staticClass: "sub" }, [
                              _vm._v(_vm._s(analyte.fraction)),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-head" }, [
      _c("h2", [_vm._v("Acceptance criteria")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "section-lede" }, [
      _vm._v(
        "\n    These settings are stored with the saved query and written to the workbook's\n    "
      ),
      _c("strong", [_vm._v("Config")]),
      _vm._v(" sheet, one setting per row.\n  "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "threshold-field" }, [
      _c(
        "p",
        { staticClass: "formula", attrs: { "aria-label": "RPD formula" } },
        [_vm._v("RPD = |P − D| / ((P + D) / 2) × 100%")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "explain" }, [
        _vm._v("\n            Comparison uses the "),
        _c("strong", [_vm._v("unrounded")]),
        _vm._v(
          " RPD. The displayed value rounds to one\n            decimal place, so a row can display "
        ),
        _c("code", [_vm._v("20.0")]),
        _vm._v(" and still fail.\n          "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip chip--success" }, [
      _c(
        "i",
        { staticClass: "material-icons", attrs: { "aria-hidden": "true" } },
        [_vm._v("playlist_add_check")]
      ),
      _vm._v("\n          Permissive by default\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }